import { gradients, themeVars } from '@libs/shared-ui-styles';

// Pro black -- used for body text
export const proBlackColor = themeVars.color.shadow._96;
export const proBlackHoverColor = themeVars.color.shadow._84;

// Black
export const blackColor = themeVars.color.black;

// White
export const whiteColor = themeVars.color.white;

// Primary colors
export const lightPrimaryColor = themeVars.color.brand.light;
export const primaryColor = themeVars.color.brand.default;
export const primaryHoverColor = themeVars.color.brand.light;
export const darkPrimaryColor = themeVars.color.brand.dark;

// Yellow timeline colors
export const yellowTimelineColor = themeVars.color.ai.color1.light;

// Cool gray
export const lighterCoolGrayColor = themeVars.color.shadow._08;
export const lightCoolGrayColor = themeVars.color.shadow._16;
export const coolGrayColor = themeVars.color.shadow._36;
export const darkCoolGrayColor = themeVars.color.shadow._56;
export const darkerCoolGrayColor = themeVars.color.shadow._72;

// Gray
export const darkerGrayColor = themeVars.color.shadow._56;
export const darkGrayColor = themeVars.color.shadow._36;
export const grayColor = themeVars.color.shadow._24;
export const lightGrayColor = themeVars.color.shadow._16;
export const lighterGrayColor = themeVars.color.shadow._08;

// Gray colors commonly used for borders/line rules
export const grayBorderColor = themeVars.color.shadow._36;
export const lightGrayBorderColor = themeVars.color.shadow._08;

// Success
export const successGreenColor = themeVars.color.positive.default;
export const lightSuccessGreenColor = themeVars.color.positive.light;

// Error
export const lightestErrorColor = themeVars.color.negative.light;
export const errorColor = themeVars.color.negative.default;

// Orange - commonly used as a cautionary background color
export const orangeHoverColor = themeVars.color.negative.light;
export const orangeColor = themeVars.color.negative.default;

// Brands
// Facebook
export const facebookColor = '#1877f2';
export const facebookHoverColor = '#0c67dc';
// Twitter
export const twitterColor = '#1da1f2';
export const twitterHoverColor = '#0d90e0';
// LinkedIn
export const linkedInColor = '#0777b5';
export const linkedInHoverColor = '#066294';

// "Brand it" gradient colors
export const brandItGradient = gradients.aiGradientD;

// Prompt suggestion gradient colors
export const promptSuggestionGradient = gradients.aiGradientE;

// Video player
export const whiteVideoIconColor = themeVars.color.white;
export const playerControlsBackgroundColor = themeVars.color.surface._56;
